import { useStrictInstance } from '@funtech-int/rival-react';

import { legacyDcbManagerRef } from '../lib/dcb';

export function useLegacyDcbManager() {
    return useStrictInstance(legacyDcbManagerRef);
}
